module.exports = __webpack_public_path__ + "img/36.a59c0037.png";